import {
  rescueModalDiscountSchema,
  rescueModalSchema,
  rescueModalUiSchema,
} from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import * as z from "zod";

export const updateCheckoutProbabilityRescueModalSettings = {
  name: "updateCheckoutProbabilityRescueModalSettings" as const,
  input: z.object({
    settings: rescueModalSchema
      .omit({ ui: true, discount: true })
      .extend({
        ui: rescueModalUiSchema
          .omit({ button: true })
          .extend({ buttonText: z.string().optional() }),
        discount: rescueModalDiscountSchema,
      }),
  }),
  output: z.null(),
};
